import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { getStoredAccessToken } from '../services/api'

export function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth()
  const location = useLocation()
  const hasAccessToken = Boolean(getStoredAccessToken())

  if (!isAuthenticated || !hasAccessToken) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return children
}
